enum ContractTypeEnum {
    Indefinite = 'indefinite',
    FixedTerm = 'fixed-term',
    ZeroHour = 'zero-hour',
    Other = 'other',
}

export default ContractTypeEnum;
